import React from "react";
import { Modal, Box, Button, Tooltip } from "@mui/material";
import { BootstrapButton } from "../../Components/Button/BootstrapButton";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

function TransferDataRak2Modal({
  isLoading,
  modalStyle,
  closeIconTarget,
  transferDataRak2ModalOpen,
  handleCloseTransferDataRak2Modal,
  handleTransferRak2,
}) {
  return (
    <Modal
      open={transferDataRak2ModalOpen}
      onClose={handleCloseTransferDataRak2Modal}
      aria-labelledby="delete-modal-title"
      aria-describedby="delete-modal-description"
      sx={{ border: 0 }}
    >
      <Box sx={modalStyle}>
        <Tooltip title="Close Transfer Data">
          <IconButton
            edge="end"
            color="inherit"
            onClick={closeIconTarget}
            sx={{ position: "absolute", top: 20, right: 30 }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <h2>Konfirmasi Transfer Data ke RAK2</h2>
        <p>Apakah anda yakin untuk transfer data ini?</p>
        <div>
          <Button
            variant="outlined"
            disableRipple
            sx={{
              width: 190,
              height: 50,
              mt: 2,
              mr: 1,
              color: "#b34469",
              borderColor: "#b34469",
            }}
            onClick={handleCloseTransferDataRak2Modal}
          >
            Cancel
          </Button>
          <BootstrapButton
            variant="contained"
            disableRipple
            sx={{ width: 182, mt: 2, height: 50, color: "#FFF" }}
            onClick={handleTransferRak2}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "TRANSFER"}
          </BootstrapButton>
        </div>
      </Box>
    </Modal>
  );
}

export default TransferDataRak2Modal;
